import React from 'react';

import { IBaseProps } from '../utils';

import styles from './RadioGroup.module.scss';

export interface IRadioGroupProps extends IBaseProps {
  /** Determines if full radio group is disabled. */
  disabled?: boolean;
  /** The unique html ID for the <fieldset> element */
  id?: string;
  /** Sets selected value of RadioGroup. */
  value?: string;
  /** Determines the orientation of the radio buttons displayed. */
  variant?: 'list' | 'row';
  /** A function that is called whenever the user changes radio button values */
  onChange?(value: string): any;
}

export const RadioGroup: React.FC<IRadioGroupProps> = (props) => {
  const handleChange = (value) => {
    if (props.onChange) props.onChange(value);
  };

  const options = React.Children.map(props.children, (item: any) => {
    const selected = props.value && item.props.value === props.value;
    const disabled = props.disabled || item.props.disabled;

    return (
      <div className={styles.option}>
        {React.cloneElement(item, { key: item.value, selected, disabled, onChange: handleChange })}
      </div>
    );
  });

  return (
    <fieldset
      id={props.id}
      className={props.variant === 'row' ? `${styles.row} ${props.className}` : `${styles.list} ${props.className}`}
      data-test={props.dataTest}
    >
      {options}
    </fieldset>
  );
};
